import { PropsWithChildren } from "react";

/**
 * The main call to action button used
 * throughout the application
 */
const PrimaryButton = ({
  type,
  children,
  className,
  disabled,
  onClick
}: PropsWithChildren<{
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}>) => (
  <button
    type={type || "button"}
    className={
      "rounded-[5px] px-4 py-2 font-medium text-white " +
      className +
      (disabled ? " bg-ctb-grey-700" : " bg-ctb-blue-200")
    }
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default PrimaryButton;
